export const alphabetical = (propertyResolver, caseInsensitive = false, asc = true) => (a, b) => {
  let propertyA = propertyResolver(a);
  let propertyB = propertyResolver(b);
  if (caseInsensitive) {
    propertyA = propertyA.toUpperCase();
    propertyB = propertyB.toUpperCase();
  }
  let result;
  if (propertyA < propertyB) {
    result = -1;
  } else if (propertyA > propertyB) {
    result = 1;
  } else {
    result = 0;
  }
  return result * (asc ? 1 : -1);
};
